webpackJsonp([0],{

/***/ "+FaE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Api_vue__ = __webpack_require__("Hw+K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9981250_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Api_vue__ = __webpack_require__("q2dv");
function injectStyle (ssrContext) {
  __webpack_require__("2KzL")
  __webpack_require__("ThCa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e9981250"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Api_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9981250_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Api_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/o5o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__ = __webpack_require__("Aqhm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6740c46b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__("C3Xb");
function injectStyle (ssrContext) {
  __webpack_require__("CrAV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6740c46b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6740c46b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/w5R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['products_cart'],
	data: function data() {
		return {
			showModal: false
		};
	},

	methods: {
		remove_from_cart: function remove_from_cart(product) {
			var prod_idx = this.products_cart.products.findIndex(function (prod, idx) {
				return prod.id == product.id;
			});
			this.products_cart.products.splice(prod_idx, 1);
			this.showModal = false;
		},
		change_qtd: function change_qtd(prod, up) {
			if (up) {
				prod.qtd += 1;
			} else if (prod.qtd > 1) {
				prod.qtd -= 1;
			}
		},
		sort_col: function sort_col(sort) {
			if (sort.type == 'desc') {
				this.products_cart.products.sort(function (a, b) {
					return a[sort.name] - b[sort.name];
				});
			} else {
				this.products_cart.products.sort(function (a, b) {
					return b[sort.name] - a[sort.name];
				});
			}
		},

		open_modal: function open_modal(prod) {
			this.modal_item = prod;
			this.showModal = true;
		}
	}
});

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "1uUu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"users"},[_c('h2',[_vm._v("Users (stored in localStorage)"),(_vm.len_users > 0)?_c('span',[_vm._v(". We already have users")]):_vm._e()]),_vm._v(" "),_c('h3',[_vm._v("Total de users: "+_vm._s(_vm.len_users))]),_vm._v(" "),_c('div',{staticClass:"form-container",on:{"keyup":function($event){if(!('button' in $event)&&$event.keyCode!==13){ return null; }_vm.add_user($event)}}},[_c('md-layout',{attrs:{"md-gutter":""}},[_c('div',{staticClass:"md-flex-50 md-flex-xsmall-100"},[_c('md-input-container',[_c('label',[_vm._v("Name")]),_vm._v(" "),_c('md-input',{ref:"name_input",model:{value:(_vm.new_user.name),callback:function ($$v) {_vm.$set(_vm.new_user, "name", $$v)},expression:"new_user.name"}})],1),_vm._v(" "),_c('md-input-container',[_c('label',[_vm._v("Phone")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.new_user.phone),callback:function ($$v) {_vm.$set(_vm.new_user, "phone", $$v)},expression:"new_user.phone"}})],1),_vm._v(" "),_c('md-button',{staticClass:"md-raised md-accent",on:{"click":_vm.add_user}},[_c('md-icon',[_vm._v("add")]),_c('span',[_vm._v("add user")])],1)],1),_vm._v(" "),_c('div',{staticClass:"md-flex-100"},[_c('small',[_vm._v(_vm._s(_vm.log))])])])],1),_vm._v(" "),_c('md-layout',{staticClass:"cards-container",attrs:{"md-gutter":""}},_vm._l((_vm.users),function(user,idx){return _c('md-layout',{key:idx,staticClass:"card-container",attrs:{"md-flex":"25","md-flex-small":"50","md-flex-xsmall":"100"}},[_c('md-whiteframe',{attrs:{"md-elevation":"4"}},[_c('md-card',[_c('md-card-header',[_c('md-card-header-text',[_c('div',{staticClass:"md-title"},[_vm._v(_vm._s(user.name))]),_vm._v(" "),_c('div',{staticClass:"md-subhead"},[_vm._v("Phone: "+_vm._s(user.phone))])]),_vm._v(" "),_c('md-menu',{attrs:{"md-size":"5","md-direction":"top left"}},[_c('md-button',{staticClass:"md-icon-button",attrs:{"md-menu-trigger":""}},[_c('md-icon',[_vm._v("contacts")])],1),_vm._v(" "),_c('md-menu-content',[_c('div',{staticClass:"author-card"},[_c('md-avatar',{staticClass:"md-large"},[_c('img',{attrs:{"src":"https://media.licdn.com/mpr/mpr/shrinknp_100_100/p/2/005/04b/1b5/18b2432.jpg","alt":"Miguel Frazão"}})]),_vm._v(" "),_c('div',{staticClass:"author-card-info"},[_c('span',[_vm._v("Miguel Frazão")]),_vm._v(" "),_c('div',{staticClass:"author-card-links"},[_c('a',{attrs:{"href":"https://www.linkedin.com/in/miguel-fraz%C3%A3o-01974274/","target":"_blank","rel":"noopener"}},[_vm._v("Linkedin")]),_vm._v(" "),_c('a',{attrs:{"href":"https://github.com/Miguel-Frazao?tab=repositories","target":"_blank","rel":"noopener"}},[_vm._v("GitHub")]),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":"http://migueldvl.com/"}},[_vm._v("Website")])])])],1)])],1)],1),_vm._v(" "),_c('md-card-area',[_c('md-card-media',[_c('div',{staticClass:"card-image",staticStyle:{"background-image":"url(https://images.pexels.com/photos/285171/pexels-photo-285171.jpeg?h=180)"}})])],1),_vm._v(" "),_c('md-card-actions',[_c('md-button',{staticClass:"md-warn md-raised delete-user",on:{"click":function($event){_vm.open_modal(user)}}},[_c('md-icon',[_vm._v("delete")]),_vm._v(" Delete user")],1)],1)],1)],1)],1)})),_vm._v(" "),(_vm.showModal)?_c('modal',{on:{"close":function($event){_vm.showModal = false}}},[_c('h3',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Delete "+_vm._s(_vm.modal_item.name)+"?")]),_vm._v(" "),_c('p',{attrs:{"slot":"body"},slot:"body"},[_vm._v("Phone: "+_vm._s(_vm.modal_item.phone))]),_vm._v(" "),_c('div',{staticClass:"align-right",attrs:{"slot":"footer"},slot:"footer"},[_c('md-button',{staticClass:"md-raised md-warn",on:{"click":function($event){_vm.delete_user(_vm.modal_item)}}},[_vm._v("\n        Yes\n      ")]),_vm._v(" "),_c('md-button',{staticClass:"md-raised",on:{"click":function($event){_vm.showModal = false}}},[_vm._v("\n        Cancel\n      ")])],1)]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2KzL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3iaX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5h3V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8gll":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar"},[_c('md-whiteframe',{staticClass:"main-toolbar",attrs:{"md-elevation":"4"}},[_c('md-toolbar',{staticClass:"top-nav-container"},[_c('div',{staticClass:"md-toolbar-container top-nav"},[_c('md-button',{staticClass:"md-icon-button md-hide-medium-and-up mob-menu-btn",on:{"click":function($event){_vm.$refs.sidebar.toggle()}}},[_c('md-icon',[_vm._v("menu")])],1),_vm._v(" "),_c('h2',{staticClass:"md-title",staticStyle:{"flex":"1"}},[_vm._v("Vuejs&Material")]),_vm._v(" "),_c('h4',{staticClass:"md-hide-medium-and-up"},[_vm._v("Cart ("+_vm._s(_vm.len_prods_cart)+"): "+_vm._s(_vm.products_cart.total)+" €")]),_vm._v(" "),_c('div',{staticClass:"desk-nav md-hide-small"},[_c('router-link',{staticClass:"top-nav-btn",attrs:{"tag":"md-button","to":"/","exact":""}},[_c('md-icon',[_vm._v("home")]),_vm._v(" "),_c('span',[_vm._v("Home")])],1),_vm._v(" "),_c('router-link',{staticClass:"top-nav-btn",attrs:{"tag":"md-button","to":"/users","exact":""}},[_c('md-icon',[_vm._v("group")]),_vm._v(" "),_c('span',[_vm._v("Users")]),_c('span',{staticClass:"badge badge-users"},[_vm._v(_vm._s(_vm.len_users))])],1),_vm._v(" "),_c('router-link',{staticClass:"top-nav-btn",attrs:{"tag":"md-button","to":"/products","exact":""}},[_c('md-icon',[_vm._v("layers")]),_vm._v(" "),_c('span',[_vm._v("Products")])],1),_vm._v(" "),_c('router-link',{staticClass:"top-nav-btn",attrs:{"tag":"md-button","to":"/cart","exact":""}},[_c('md-icon',[_vm._v("shopping_cart")]),_vm._v(" "),_c('span',[_vm._v("Cart")]),_c('span',{staticClass:"badge badge-cart"},[_vm._v(_vm._s(_vm.len_prods_cart))])],1),_vm._v(" "),_c('md-menu',{attrs:{"md-align-trigger":"","md-size":"4"}},[_c('md-button',{staticClass:"top-nav-btn",attrs:{"md-menu-trigger":""}},[_c('md-icon',[_vm._v("keyboard_arrow_down")]),_vm._v(" "),_c('span',[_vm._v("Dropdown")])],1),_vm._v(" "),_c('md-menu-content',[_c('router-link',{attrs:{"to":"#","tag":"md-menu-item"}},[_vm._v("Dropdown 1")]),_vm._v(" "),_c('router-link',{attrs:{"to":"#","tag":"md-menu-item"}},[_vm._v("Dropdown 2")]),_vm._v(" "),_c('router-link',{attrs:{"to":"#","tag":"md-menu-item"}},[_vm._v("Just another dropdown")])],1)],1),_vm._v(" "),_c('router-link',{staticClass:"top-nav-btn",attrs:{"tag":"md-button","to":"/api","exact":""}},[_c('md-icon',[_vm._v("code")]),_vm._v(" "),_c('span',[_vm._v("Api Req")])],1)],1)],1)])],1),_vm._v(" "),_c('md-sidenav',{ref:"sidebar",staticClass:"md-dense md-left md-fixed mob-nav md-hide-medium-and-up"},[_c('md-toolbar',{staticClass:"md-large"},[_c('div',{staticClass:"md-toolbar-container"},[_c('h3',{staticClass:"md-title"},[_vm._v("Sidenav content")])])]),_vm._v(" "),_c('md-list',{staticClass:"md-accent"},[_c('md-list-item',{nativeOn:{"click":function($event){_vm.$refs.sidebar.toggle()}}},[_c('router-link',{attrs:{"to":"/","exact":""}},[_c('span',[_vm._v("Home")]),_vm._v(" "),_c('md-icon',[_vm._v("home")])],1)],1),_vm._v(" "),_c('md-list-item',{nativeOn:{"click":function($event){_vm.$refs.sidebar.toggle()}}},[_c('router-link',{attrs:{"to":"/users","exact":""}},[_c('span',[_vm._v("Users"),_c('span',{staticClass:"badge badge-users mob-badge"},[_vm._v(_vm._s(_vm.len_users))])]),_vm._v(" "),_c('md-icon',[_vm._v("group")])],1)],1),_vm._v(" "),_c('md-list-item',{nativeOn:{"click":function($event){_vm.$refs.sidebar.toggle()}}},[_c('router-link',{attrs:{"to":"/products","exact":""}},[_c('span',[_vm._v("Products")]),_vm._v(" "),_c('md-icon',[_vm._v("layers")])],1)],1),_vm._v(" "),_c('md-list-item',{nativeOn:{"click":function($event){_vm.$refs.sidebar.toggle()}}},[_c('router-link',{attrs:{"to":"/cart","exact":""}},[_c('span',[_vm._v("Cart"),_c('span',{staticClass:"badge badge-cart mob-badge"},[_vm._v(_vm._s(_vm.len_prods_cart))])]),_vm._v(" "),_c('md-icon',[_vm._v("shopping_cart")])],1)],1),_vm._v(" "),_c('md-list-item',[_c('span',[_vm._v("Dropdown")]),_vm._v(" "),_c('md-list-expand',[_c('md-list',[_c('md-list-item',[_c('router-link',{attrs:{"exact":"","to":"/"}},[_vm._v("Dropdown 1")])],1),_vm._v(" "),_c('md-list-item',[_c('router-link',{attrs:{"exact":"","to":"/"}},[_vm._v("Dropdown 2")])],1),_vm._v(" "),_c('md-list-item',[_c('router-link',{attrs:{"exact":"","to":"/"}},[_vm._v("Just another dropdown")])],1)],1)],1)],1),_vm._v(" "),_c('md-list-item',{nativeOn:{"click":function($event){_vm.$refs.sidebar.toggle()}}},[_c('router-link',{attrs:{"to":"/api","exact":""}},[_c('span',[_vm._v("Api Req")]),_vm._v(" "),_c('md-icon',[_vm._v("code")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9sd5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Aqhm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "C3Xb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask",on:{"click":function($event){_vm.$emit('close')}}},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"close-container"},[_c('button',{staticClass:"close-btn",on:{"click":function($event){_vm.$emit('close')}}},[_vm._v("×")])]),_vm._v(" "),_c('div',{staticClass:"modal-header"},[_vm._t("header",[_vm._v("\n              default header\n          ")])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("body",[_vm._v("\n              default body\n          ")])],2),_vm._v(" "),_c('div',{staticClass:"modal-footer align-right"},[_vm._t("footer",[_vm._v("\n            default footer\n          ")])],2)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CrAV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Cwn0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Product_vue__ = __webpack_require__("ctzt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_028cd42d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Product_vue__ = __webpack_require__("eQtW");
function injectStyle (ssrContext) {
  __webpack_require__("Z4pK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-028cd42d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Product_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_028cd42d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Product_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DEtk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['products_cart', 'len_users'],
	computed: {
		len_prods_cart: function len_prods_cart() {
			return this.products_cart.products.length;
		}
	}
});

/***/ }),

/***/ "Fs8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hello_message: 'Vuejs&Material demo'
    };
  }
});

/***/ }),

/***/ "Hw+K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			news: [],
			loading: false,
			new_id: 8863
		};
	},

	methods: {
		get_new: function get_new() {
			var _this = this;

			this.$http.get('https://hacker-news.firebaseio.com/v0/item/' + this.new_id + '.json', {
				before: function before(request) {
					this.loading = true;
				}
			}).then(function (response) {
				_this.news.unshift(response.body); // add to the begining of array so we can keep the new one in first
				_this.loading = false;
			}, function (response) {
				alert('ajax error' + response.status);
			}).then(function (response) {
				_this.new_id += 1;
			});
		}
	}
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5e7cf8c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("q8Yf");
function injectStyle (ssrContext) {
  __webpack_require__("iNOD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5e7cf8c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MG0w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cart"},[_c('md-table-card',{staticClass:"md-hide-xsmall"},[_c('md-card-header',[_c('h1',[_vm._v("Total price: "+_vm._s(_vm.products_cart.total)+" €")])]),_vm._v(" "),_c('md-table',{staticClass:"responsive-table",on:{"sort":_vm.sort_col}},[_c('md-table-header',[_c('md-table-row',[_c('md-table-head',[_vm._v("Picture")]),_vm._v(" "),_c('md-table-head',[_vm._v("Name")]),_vm._v(" "),_c('md-table-head',{attrs:{"md-sort-by":"qtd"}},[_vm._v("Qtd")]),_vm._v(" "),_c('md-table-head',{attrs:{"md-sort-by":"total"}},[_vm._v("Total (€)")]),_vm._v(" "),_c('md-table-head',{staticClass:"align-center"},[_vm._v("Actions")])],1)],1),_vm._v(" "),_c('md-table-body',_vm._l((_vm.products_cart.products),function(prod,index){return _c('md-table-row',{key:index},[_c('md-table-cell',[_c('img',{staticClass:"table-image",attrs:{"src":prod.picture}})]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(prod.name))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(prod.qtd))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(prod.total))]),_vm._v(" "),_c('md-table-cell',{staticClass:"align-center"},[_c('md-button',{staticClass:"md-icon-button md-raised md-accent",on:{"click":function($event){_vm.change_qtd(prod, true)}}},[_c('md-icon',[_vm._v("add")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"top"}},[_vm._v("More product")])],1),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button md-raised",on:{"click":function($event){_vm.change_qtd(prod, false)}}},[_c('md-icon',[_vm._v("remove")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"top"}},[_vm._v("Less product")])],1),_vm._v(" "),_c('router-link',{staticClass:"md-icon-button md-raised md-primary",attrs:{"tag":"md-button","to":'/product/' +prod.id}},[_c('md-icon',[_vm._v("remove_red_eye")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"top"}},[_vm._v("Check product")])],1),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button md-raised md-warn",on:{"click":function($event){_vm.open_modal(prod)}}},[_c('md-icon',[_vm._v("delete")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"top"}},[_vm._v("Remove from cart")])],1)],1)],1)}))],1)],1),_vm._v(" "),_c('div',{staticClass:"mob-display md-hide-small-and-up"},[_c('div',{staticClass:"cards-container"},_vm._l((_vm.products_cart.products),function(prod){return _c('div',{key:prod.id,staticClass:"card-container"},[_c('md-whiteframe',{attrs:{"md-elevation":"0"}},[_c('md-card',[_c('md-card-header',[_c('md-card-header-text',[_c('div',{staticClass:"md-title"},[_vm._v(_vm._s(prod.name))]),_vm._v(" "),_c('div',{staticClass:"md-subhead"},[_vm._v("Price: "+_vm._s(prod.value)+" €")]),_vm._v(" "),_c('div',{staticClass:"md-subhead"},[_vm._v("Quantity: "+_vm._s(prod.qtd))])]),_vm._v(" "),_c('md-menu',{attrs:{"md-size":"4","md-direction":"bottom left"}},[_c('md-button',{staticClass:"md-icon-button",attrs:{"md-menu-trigger":""}},[_c('md-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('md-menu-content',[_c('md-menu-item',[_c('span',[_vm._v("Call")]),_vm._v(" "),_c('md-icon',[_vm._v("phone")])],1),_vm._v(" "),_c('md-menu-item',[_c('span',[_vm._v("Send a message")]),_vm._v(" "),_c('md-icon',[_vm._v("message")])],1)],1)],1)],1),_vm._v(" "),_c('md-card-media',[_c('img',{attrs:{"src":prod.picture,"alt":'product' +prod.name}})]),_vm._v(" "),_c('md-card-actions',[_c('md-card-content',[_c('h3',{staticClass:"md-subheading"},[_vm._v("Total: "+_vm._s(prod.total)+" €")])]),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button md-raised md-accent",on:{"click":function($event){_vm.change_qtd(prod, true)}}},[_c('md-icon',[_vm._v("add")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"top"}},[_vm._v("More product")])],1),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button md-raised",on:{"click":function($event){_vm.change_qtd(prod, false)}}},[_c('md-icon',[_vm._v("remove")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"top"}},[_vm._v("Less product")])],1),_vm._v(" "),_c('router-link',{staticClass:"md-icon-button md-raised md-primary",attrs:{"tag":"md-button","to":'/product/' +prod.id}},[_c('md-icon',[_vm._v("remove_red_eye")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"top"}},[_vm._v("Check product")])],1),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button md-raised md-warn",on:{"click":function($event){_vm.open_modal(prod)}}},[_c('md-icon',[_vm._v("delete")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"top"}},[_vm._v("Remove from cart")])],1)],1)],1)],1)],1)}))]),_vm._v(" "),(_vm.showModal)?_c('modal',{on:{"close":function($event){_vm.showModal = false}}},[_c('h3',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Delete "+_vm._s(_vm.modal_item.name)+" from cart?")]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('md-button',{staticClass:"md-raised md-warn",on:{"click":function($event){_vm.remove_from_cart(_vm.modal_item)}}},[_vm._v("\n\t\t\t\tYes\n\t\t\t")]),_vm._v(" "),_c('md-button',{staticClass:"md-raised",on:{"click":function($event){_vm.showModal = false}}},[_vm._v("\n\t\t\t\tCancel\n\t\t\t")])],1)]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__("ORbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_material__ = __webpack_require__("Lgyv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_material__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Api__ = __webpack_require__("+FaE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Home__ = __webpack_require__("lO7g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Cart__ = __webpack_require__("Zc39");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Modal__ = __webpack_require__("/o5o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Users__ = __webpack_require__("TKn+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_NavBar__ = __webpack_require__("g2+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Product__ = __webpack_require__("Cwn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Products__ = __webpack_require__("mBSZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_NotFound__ = __webpack_require__("YcJa");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_material___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].material.registerTheme({
	default: {
		primary: {
			color: 'blue',
			hue: 500,
			textColor: 'white'
		},
		accent: {
			color: 'green',
			hue: 600,
			textColor: 'white'
		},
		warn: {
			color: 'red',
			hue: 500,
			textColor: 'white'
		},
		background: 'white'
	}
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].material.setCurrentTheme('default');

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('nav-bar', __WEBPACK_IMPORTED_MODULE_10__components_NavBar__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('modal', __WEBPACK_IMPORTED_MODULE_8__components_Modal__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
	routes: [{
		path: '/',
		component: __WEBPACK_IMPORTED_MODULE_6__components_Home__["a" /* default */],
		meta: { page_title: 'Vuejs&Material Demo | Home' }
	}, {
		path: '/users',
		component: __WEBPACK_IMPORTED_MODULE_9__components_Users__["a" /* default */],
		meta: { page_title: 'Vuejs&Material Demo | Users' }
	}, {
		path: '/api',
		component: __WEBPACK_IMPORTED_MODULE_5__components_Api__["a" /* default */],
		meta: { page_title: 'Vuejs&Material Demo | Api' }
	}, {
		path: '/products',
		component: __WEBPACK_IMPORTED_MODULE_12__components_Products__["a" /* default */],
		meta: { page_title: 'Vuejs&Material Demo | Products' }
	}, {
		path: '/product/:id',
		component: __WEBPACK_IMPORTED_MODULE_11__components_Product__["a" /* default */],
		meta: { page_title: 'Vuejs&Material Demo | Product' }
	}, {
		path: '/cart',
		component: __WEBPACK_IMPORTED_MODULE_7__components_Cart__["a" /* default */],
		meta: { page_title: 'Vuejs&Material Demo | Cart' }
	}, {
		path: '/*',
		component: __WEBPACK_IMPORTED_MODULE_13__components_NotFound__["a" /* default */],
		meta: { page_title: 'Vuejs&Material Demo | 404 NOT FOUND' }
	}]
});

router.beforeEach(function (to, from, next) {
	document.title = to.meta.page_title;
	gtag('config', 'UA-108117243-1', { 'page_path': to.path });
	next();
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
	el: '#app',
	template: '<App/>',
	components: { App: __WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */] },
	router: router
});

/***/ }),

/***/ "TKn+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__ = __webpack_require__("dxC/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09979b74_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__ = __webpack_require__("1uUu");
function injectStyle (ssrContext) {
  __webpack_require__("5h3V")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-09979b74"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09979b74_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ThCa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WoGI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "YcJa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFound_vue__ = __webpack_require__("WoGI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27eacc21_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__ = __webpack_require__("jgHe");
function injectStyle (ssrContext) {
  __webpack_require__("sHmB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-27eacc21"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFound_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27eacc21_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Z4pK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zc39":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cart_vue__ = __webpack_require__("/w5R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6b5c95c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cart_vue__ = __webpack_require__("MG0w");
function injectStyle (ssrContext) {
  __webpack_require__("qbvk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b6b5c95c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6b5c95c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cf9R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home align-center"},[_c('h1',[_vm._v(_vm._s(_vm.hello_message))]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('md-button',{staticClass:"md-raised md-primary",attrs:{"target":"_blank","href":"https://github.com/Miguel-Frazao/vuejs-material-demo"}},[_vm._v("Github")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('code',[_vm._v("git clone https://github.com/Miguel-Frazao/vuejs-material-demo")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('md-button',{staticClass:"md-raised md-primary",attrs:{"download":"","href":"https://github.com/Miguel-Frazao/vuejs-material-demo/archive/master.zip"}},[_vm._v("Download")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("This simple project was based on "),_c('a',{attrs:{"href":"http://vuematerial.io","target":"_blank"}},[_vm._v("vue-material")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('code',[_vm._v("\n  cd path/to/this\n  "),_c('br'),_vm._v("\n  npm install\n  "),_c('br'),_vm._v("\n  npm run dev\n  ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cqko":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"products"},[_c('md-layout',{staticClass:"md-row"},[_c('div',{staticClass:"md-flex-50 md-hide-xsmall"}),_vm._v(" "),_c('md-input-container',{staticClass:"md-flex-50 md-flex-xsmall-100"},[_c('label',{attrs:{"for":"sort_price"}},[_vm._v("Sort by price")]),_vm._v(" "),_c('md-select',{attrs:{"name":"country","id":"sort_price"},on:{"change":_vm.sort_price},model:{value:(_vm.sort_dir),callback:function ($$v) {_vm.sort_dir=$$v},expression:"sort_dir"}},[_c('md-option',{attrs:{"value":"up"}},[_vm._v("Upward")]),_vm._v(" "),_c('md-option',{attrs:{"value":"down"}},[_vm._v("Downward")])],1)],1)],1),_vm._v(" "),_c('md-layout',{staticClass:"cards-container",attrs:{"md-gutter":""}},_vm._l((_vm.products),function(prod){return _c('md-layout',{key:prod.id,staticClass:"card-container md-flex-25 md-flex-small-50 md-flex-xsmall-100"},[_c('md-whiteframe',{attrs:{"md-elevation":"4"}},[_c('md-card',{attrs:{"md-with-hover":""}},[_c('md-card-area',[_c('router-link',{staticClass:"prod-anchor",attrs:{"to":'/product/' +prod.id}},[_c('md-card-header',[_c('div',{staticClass:"md-title"},[_vm._v(_vm._s(prod.name))])]),_vm._v(" "),_c('md-card-media',[_c('div',{staticClass:"card-image",style:({backgroundImage: 'url(' +prod.picture+ ')'})})]),_vm._v(" "),_c('md-card-content',{staticClass:"description"},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(prod.description)+"\n\t\t\t\t\t\t\t")])],1)],1),_vm._v(" "),_c('md-card-actions',[_c('md-card-content',{staticClass:"prod-value"},[_c('p',{staticClass:"md-subheading"},[_vm._v(_vm._s(prod.value)+" €")])]),_vm._v(" "),(_vm.prod_in_cart(prod))?_c('md-button',{staticClass:"md-raised md-accent",attrs:{"disabled":""}},[_vm._v("On Cart")]):_c('md-button',{staticClass:"md-icon-button md-raised md-primary md-accent",on:{"click":function($event){_vm.add_to_cart(prod)}}},[_c('md-icon',[_vm._v("add_shopping_cart")])],1)],1)],1)],1)],1)}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ctzt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['products_cart'],
	data: function data() {
		return {
			products: [{
				id: 1,
				name: 'Eagle',
				value: 100,
				picture: 'https://images.pexels.com/photos/133356/pexels-photo-133356.jpeg',
				description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Optio itaque ea, nostrum odio. Dolores, sed accusantium quasi non, voluptas eius illo quas, saepe voluptate pariatur in deleniti minus sint. Excepturi.'
			}, {
				id: 2,
				name: 'Duck',
				value: 200,
				picture: 'https://images.pexels.com/photos/255416/pexels-photo-255416.jpeg',
				description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Optio itaque ea, '
			}, {
				id: 3,
				name: 'Parrot',
				value: 300,
				picture: 'https://image.freepik.com/free-photo/parrot-jpg_21160030.jpg',
				description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Optio itaque ea, llo quas, saepe voluptate pariatur in deleniti minus sint. Excepturi'
			}, {
				id: 4,
				name: 'Seagull',
				value: 400,
				picture: 'https://i.pinimg.com/originals/e0/63/8c/e0638cc91d2e6302608cd5f899e83529.jpg',
				description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Optio itaque ea, '
			}]
		};
	},

	computed: {
		product: function product() {
			var _this = this;

			return this.products.find(function (product) {
				return product.id == _this.$route.params.id;
			});
		}
	},
	created: function created() {
		if (typeof this.product == 'undefined') {
			this.$router.push({ path: '/404' });
		}
	}
});

/***/ }),

/***/ "dxC/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['users'],
  data: function data() {
    return {
      showModal: false,
      log: '',
      new_user: { name: '', phone: '' }
    };
  },

  methods: {
    add_user: function add_user() {
      if (this.new_user.name.trim() == '' || this.new_user.phone.trim() == '') {
        alert('fill in all data correcly');
        return;
      }
      this.users.push(this.new_user);
      localStorage.setItem("users", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.users));
      this.new_user = { name: '', phone: '' };
      this.$refs.name_input.$el.focus();
    },
    delete_user: function delete_user(user) {
      this.users.splice(this.users.findIndex(function (u, idx) {
        return u == user;
      }), 1);
      localStorage.setItem("users", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.users));
      this.showModal = false;
    },
    open_modal: function open_modal(item) {
      this.modal_item = item;
      this.showModal = true;
    }
  },
  watch: {
    len_users: function len_users(new_val, old_val) {
      this.log = 'We have ' + new_val + ' users now, not ' + old_val + ' anymore';
    }
  },
  computed: {
    len_users: function len_users() {
      return this.users.length;
    }
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.$refs.name_input.$el.focus();
    }, 100); // settimeout, only way I got focus to work
  }
});

/***/ }),

/***/ "eQtW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product"},[_vm._v("\n\tRoute params: "+_vm._s(_vm.$route.params)+"\n\t"),_c('br'),_vm._v("\n\tGet prod: "+_vm._s(_vm.product)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "g2+m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavBar_vue__ = __webpack_require__("DEtk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_302f5da2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavBar_vue__ = __webpack_require__("8gll");
function injectStyle (ssrContext) {
  __webpack_require__("u7g7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-302f5da2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_302f5da2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iNOD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j5Ze":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['products_cart'],
	data: function data() {
		return {
			sort_dir: '',
			products: [{
				id: 1,
				name: 'Eagle',
				value: 100,
				picture: 'https://images.pexels.com/photos/133356/pexels-photo-133356.jpeg',
				description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Optio itaque ea, nostrum odio. Dolores, sed accusantium quasi non, voluptas eius illo quas, saepe voluptate pariatur in deleniti minus sint. Excepturi.'
			}, {
				id: 2,
				name: 'Duck',
				value: 200,
				picture: 'https://images.pexels.com/photos/255416/pexels-photo-255416.jpeg',
				description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Optio itaque ea, '
			}, {
				id: 3,
				name: 'Parrot',
				value: 300,
				picture: 'https://image.freepik.com/free-photo/parrot-jpg_21160030.jpg',
				description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Optio itaque ea, llo quas, saepe voluptate pariatur in deleniti minus sint. Excepturi'
			}, {
				id: 4,
				name: 'Seagull',
				value: 400,
				picture: 'https://i.pinimg.com/originals/e0/63/8c/e0638cc91d2e6302608cd5f899e83529.jpg',
				description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Optio itaque ea, '
			}]
		};
	},

	methods: {
		prod_in_cart: function prod_in_cart(prod) {
			return this.products_cart.products.findIndex(function (p, idx) {
				return p.id == prod.id;
			}) !== -1;
		},
		add_to_cart: function add_to_cart(prod) {
			// NOTE: DO NOT this.products_cart.products.push(prod) ... THIS WILL GENERATE A CONFLIT BECAUSE products_cart AND products WILL SHARE THE SAME DEEP OBJECT (SAME MEMORY SPACE)
			this.products_cart.products.push({ picture: prod.picture, id: prod.id, value: prod.value, qtd: 1, name: prod.name });
		},
		sort_price: function sort_price() {
			if (this.sort_dir == 'up') {
				this.products.sort(function (a, b) {
					return a.value - b.value;
				});
			} else {
				this.products.sort(function (a, b) {
					return b.value - a.value;
				});
			}
		}
	}
});

/***/ }),

/***/ "jgHe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("404 yoo... not found")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lO7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("Fs8J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f172c4de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("cf9R");
function injectStyle (ssrContext) {
  __webpack_require__("3iaX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f172c4de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f172c4de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mBSZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Products_vue__ = __webpack_require__("j5Ze");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52b95296_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Products_vue__ = __webpack_require__("cqko");
function injectStyle (ssrContext) {
  __webpack_require__("9sd5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-52b95296"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Products_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52b95296_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Products_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "q2dv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"api"},[_c('transition',{attrs:{"name":"fade"}},[(_vm.loading)?_c('div',{staticClass:"loader"},[_c('div',[_c('md-spinner',{attrs:{"md-size":60,"md-indeterminate":""}}),_vm._v(" "),_c('br'),_vm._v("\n\t\t\t\tLoading\n\t\t\t")],1)]):_vm._e()]),_vm._v(" "),_c('md-button',{staticClass:"md-raised md-accent",on:{"click":_vm.get_new}},[_c('md-icon',[_vm._v("add")]),_c('span',[_vm._v("Request more")])],1),_vm._v(" "),_vm._l((_vm.news),function(n){return _c('p',{key:n.id},[_c('span',[_vm._v("id: "+_vm._s(n.id))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("by: "+_vm._s(n.by))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("title: "+_vm._s(n.title))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("Url: "),_c('a',{attrs:{"target":"_blank","href":n.url}},[_vm._v(_vm._s(n.url))])]),_vm._v(" "),_c('br'),_c('br')])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "q8Yf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('nav-bar',{ref:"navBar",attrs:{"products_cart":_vm.products_cart,"len_users":_vm.users.length}}),_vm._v(" "),_c('div',{staticClass:"main-container"},[_c('router-view',{key:_vm.$route.path,attrs:{"users":_vm.users,"products_cart":_vm.products_cart}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qbvk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sHmB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u7g7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      users: JSON.parse(localStorage.getItem("users")) || [],
      products_cart: { total: 0, products: [] }
    };
  },

  watch: {
    total_cart: function total_cart(new_val, old_val) {
      this.products_cart.total = new_val;
    }
  },
  computed: {
    total_cart: function total_cart() {
      return this.products_cart.products.reduce(function (sum, p) {
        p.total = p.qtd * p.value;
        return sum + p.total;
      }, 0);
    }
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.ff6a087393ee7aea0e16.js